package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.tabularNums
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input

@Composable
fun DatePicker(
    value: String,
    onChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    label: String? = null,
    min: String? = null,
    max: String? = null,
    widthPx: Int? = null,
    size: ControlSize = ControlSize.Md,
    help: String? = null,
    error: String? = null,
    hint: String? = null,
    required: Boolean = false,
    disabled: Boolean = false,
    ariaLabel: String? = null,
    reserveMessageSpace: Boolean = false,
) {
    val metrics = size.metrics
    FormField(
        label = label,
        modifier = if (widthPx != null) modifier.width(widthPx.px) else modifier,
        hint = hint,
        help = help,
        error = error,
        required = required,
        reserveMessageSpace = reserveMessageSpace,
    ) { field ->
        Input(
            type = InputType.Date,
            attrs = fieldBoxLook(metrics)
                .tabularNums()
                .styleModifier {
                    property("width", "100%")
                    property("color-scheme", "light dark")
                }
                .toAttrs {
                    value(value)
                    min?.let { attr("min", it) }
                    max?.let { attr("max", it) }
                    if (disabled) attr("disabled", "")
                    ariaLabel?.let { attr("aria-label", it) }
                    fieldControl(field)
                    onInput { e -> onChange(e.value.trim()) }
                },
        )
    }
}

@Composable
fun TimePicker(
    value: String,
    onChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    label: String? = null,
    step: Int? = null,
    widthPx: Int? = null,
    size: ControlSize = ControlSize.Md,
    help: String? = null,
    error: String? = null,
    hint: String? = null,
    required: Boolean = false,
    disabled: Boolean = false,
    ariaLabel: String? = null,
    reserveMessageSpace: Boolean = false,
) {
    val metrics = size.metrics
    FormField(
        label = label,
        modifier = if (widthPx != null) modifier.width(widthPx.px) else modifier,
        hint = hint,
        help = help,
        error = error,
        required = required,
        reserveMessageSpace = reserveMessageSpace,
    ) { field ->
        Input(
            type = InputType.Time,
            attrs = fieldBoxLook(metrics)
                .tabularNums()
                .styleModifier {
                    property("width", "100%")
                    property("color-scheme", "light dark")
                }
                .toAttrs {
                    value(value)
                    step?.let { attr("step", it.toString()) }
                    if (disabled) attr("disabled", "")
                    ariaLabel?.let { attr("aria-label", it) }
                    fieldControl(field)
                    onInput { e -> onChange(e.value.trim()) }
                },
        )
    }
}
